import { Form, Row, Col, Spin, Input } from "antd";
import { useSelector } from "react-redux";
import { useCamposServicio } from "./useCamposServicio";
import { CampoServicioItem } from "./CampoServicioItem";

export const CamposServicio = ({
  valoresCampos,
  onCampoChange,
  datosAdicionales,
  onDatosAdicionalesChange,
}) => {
  const { captura, capturaCampos } = useSelector((state) => state.asistenciasReducer);
  const { loading, camposOpciones } = useCamposServicio(captura.servicioID);

  return (
    <Spin spinning={loading}>
      <Form layout="vertical" size="large">
        <Row gutter={12}>
          {(capturaCampos || []).map((campo) => (
            <CampoServicioItem
              key={campo.id}
              campo={campo}
              campaniaID={captura.campaniaID}
              value={valoresCampos[campo.id]}
              opciones={camposOpciones[campo.id]}
              onCampoChange={onCampoChange}
            />
          ))}
          <Col xs={24}>
            <Form.Item label="Datos adicionales">
              <Input.TextArea
                rows={3}
                value={datosAdicionales || ""}
                onChange={onDatosAdicionalesChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};
